(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-gate"] && !Shopify.designMode) return;
  try {
    
(function () {
  var gate = document.querySelector('[data-age-gate]');
  if (!gate) return;
  // Auto-hide when inside Shopify's theme editor so the merchant can
  // customize the home page without the overlay blocking everything.
  if (window.Shopify && window.Shopify.designMode) {
    gate.style.display = 'none';
    document.body.classList.remove('lock-scroll');
    return;
  }
  var KEY = 'chorus_age_ok';
  var ok;
  try { ok = localStorage.getItem(KEY) === '1'; } catch (e) { ok = false; }
  if (!ok) {
    gate.style.display = 'flex';
    document.body.classList.add('lock-scroll');
  }
  var confirm = gate.querySelector('[data-age-gate-confirm]');
  var deny = gate.querySelector('[data-age-gate-deny]');
  if (confirm) confirm.addEventListener('click', function () {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    gate.style.display = 'none';
    document.body.classList.remove('lock-scroll');
  });
  if (deny) deny.addEventListener('click', function () {
    alert('Please come back when you are of legal drinking age.');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  function open() {
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lock-scroll');
  }
  function close() {
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lock-scroll');
  }

  // Always fetch from "/" — on product pages Shopify's section rendering API
  // intercepts ?sections= and serves the product section instead of the requested one.
  // Cart drawer state is global (depends on cart.items), so root path always works.
  function fetchDrawerSection() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function swapDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = sections['cart-drawer'].trim();
    var fresh = wrap.querySelector('[data-cart-drawer]');
    if (fresh) {
      drawer.innerHTML = fresh.innerHTML;
      bindDrawerControls();
    }
  }

  function updateBadge() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-badge]').forEach(function (b) {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      // Also keep the cart link's data-cart-count attribute in sync
      document.querySelectorAll('.site-util--cart').forEach(function (a) {
        a.setAttribute('data-cart-count', cart.item_count);
      });
      // And the inner drawer count
      var inner = drawer.querySelector('[data-cart-count]');
      if (inner) inner.textContent = '(' + cart.item_count + ')';
      return cart;
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(fetchDrawerSection)
      .then(swapDrawer)
      .then(updateBadge);
  }

  function bindDrawerControls() {
    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    drawer.querySelectorAll('.cart-line').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var qtyEl = line.querySelector('[data-cart-qty]');
      if (!key || !qtyEl) return;
      var up = line.querySelector('[data-cart-qty-up]');
      var down = line.querySelector('[data-cart-qty-down]');
      var remove = line.querySelector('[data-cart-remove]');
      if (up) up.addEventListener('click', function () {
        var qty = parseInt(qtyEl.textContent, 10) + 1;
        changeLine(key, qty);
      });
      if (down) down.addEventListener('click', function () {
        var qty = parseInt(qtyEl.textContent, 10) - 1;
        if (qty < 0) qty = 0;
        changeLine(key, qty);
      });
      if (remove) remove.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(key, 0);
      });
    });
  }

  bindDrawerControls();

  // Open via header cart button
  document.querySelectorAll('.site-util--cart').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });

  // Featured-product form intercept for AJAX add
  document.querySelectorAll('[data-featured-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(fetchDrawerSection)
        .then(function (sections) {
          swapDrawer(sections);
          updateBadge();
          open();
        })
        .catch(function () { form.submit(); /* hard fallback */ });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Format a price (in pennies) into the store's money_format. The format
  // template is rendered server-side by Liquid onto the [data-atb-total]
  // element as data-currency-format, so this code stays currency-agnostic.
  // Supports the placeholders Shopify exposes via shop.money_format.
  function formatMoney(pennies, format) {
    var pounds = pennies / 100;
    var withDecimals = pounds.toFixed(2);
    // Strip trailing zeros on whole-pound prices (£19.95 stays, £20.00 → £20).
    var trimmed = withDecimals.endsWith('.00') ? withDecimals.slice(0, -3) : withDecimals;
    var noDecimals = Math.round(pounds).toString();
    return (format || '£{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, trimmed)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, trimmed)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  function initStepper(root) {
    var minus = root.querySelector('[data-qty-decrement]');
    var plus  = root.querySelector('[data-qty-increment]');
    var input = root.querySelector('[data-qty-input]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initVariantPicker() {
    var options = document.querySelectorAll('[data-variant-option]');
    if (options.length === 0) return;

    // Track selection via data-selected attribute (reliable, decoupled from CSS).
    // Find the initially-checked radio.
    var initial = null;
    options.forEach(function (o) {
      var r = o.querySelector('input[type="radio"]');
      if (r && r.checked) initial = o;
    });
    if (!initial) initial = options[0];
    initial.setAttribute('data-selected', 'true');

    function selectOption(opt) {
      var radio = opt.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      // Visual + state
      options.forEach(function (o) {
        var on = (o === opt);
        if (on) {
          o.setAttribute('data-selected', 'true');
        } else {
          o.removeAttribute('data-selected');
        }
        o.style.background  = on ? 'var(--chorus-black)' : 'transparent';
        o.style.color       = on ? 'var(--chorus-chalk)' : 'var(--chorus-black)';
        o.style.borderColor = on ? 'var(--chorus-black)' : 'var(--hairline-strong)';
      });
      // Update active price + descriptor displays
      var priceStr = opt.getAttribute('data-variant-price') || '';
      var desc = opt.getAttribute('data-variant-descriptor') || '';
      document.querySelectorAll('[data-active-price]').forEach(function (el) {
        el.textContent = priceStr;
      });
      document.querySelectorAll('[data-active-descriptor]').forEach(function (el) {
        el.textContent = desc;
      });
      updateAtbTotal();
    }

    function updateAtbTotal() {
      var selected = document.querySelector('[data-variant-option][data-selected="true"]') || options[0];
      if (!selected) return;
      var pennies = parseInt(selected.getAttribute('data-variant-price-pennies'), 10) || 0;
      var qtyEl = document.querySelector('[data-qty-input]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      var atb = document.querySelector('[data-atb-total]');
      if (atb) atb.textContent = formatMoney(pennies * qty, atb.getAttribute('data-currency-format'));
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () { selectOption(opt); });
    });

    var qtyEl = document.querySelector('[data-qty-input]');
    if (qtyEl) {
      qtyEl.addEventListener('input', updateAtbTotal);
      qtyEl.addEventListener('change', updateAtbTotal);
    }
    updateAtbTotal();
  }

  function initPreview() {
    var buttons = document.querySelectorAll('[data-preview-variant]');
    if (!buttons.length) return;
    var prices = { single: 19.95, case: 105.00 };
    var current = 'single';

    function applySelection() {
      buttons.forEach(function (b) {
        var sel = b.getAttribute('data-preview-variant') === current;
        b.setAttribute('aria-pressed', sel ? 'true' : 'false');
        b.style.background = sel ? 'var(--chorus-black)' : 'transparent';
        b.style.color = sel ? 'var(--chorus-chalk)' : 'var(--chorus-black)';
        b.style.borderColor = sel ? 'var(--chorus-black)' : 'var(--hairline-strong)';
      });
      updateTotal();
    }

    function updateTotal() {
      var qtyInput = document.querySelector('[data-preview-atb]')
        && document.querySelector('[data-preview-atb]').closest('div').querySelector('[data-qty-input]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var total = prices[current] * qty;
      var span = document.querySelector('[data-preview-total]');
      if (span) span.textContent = '£' + total.toFixed(2);
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        current = b.getAttribute('data-preview-variant');
        applySelection();
      });
    });
    document.querySelectorAll('[data-qty-input]').forEach(function (i) {
      i.addEventListener('change', updateTotal);
      i.addEventListener('input', updateTotal);
    });
    applySelection();
  }

  function boot() {
    document.querySelectorAll('[data-qty-stepper]').forEach(initStepper);
    initVariantPicker();
    initPreview();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  function open() {
    menu.setAttribute('data-open', 'true');
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lock-scroll');
  }
  function close() {
    menu.setAttribute('data-open', 'false');
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lock-scroll');
  }
  // Hook into the existing hamburger button
  document.querySelectorAll('.site-hamburger').forEach(function (b) {
    b.addEventListener('click', function () {
      b.setAttribute('aria-expanded', 'true');
      open();
    });
  });
  menu.querySelectorAll('[data-mobile-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      var ham = document.querySelector('.site-hamburger');
      if (ham) ham.setAttribute('aria-expanded', 'false');
      close();
    });
  });
  // Esc closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu.getAttribute('data-open') === 'true') close();
  });
  // Clicking a nav link closes the menu
  menu.querySelectorAll('.mobile-menu__link').forEach(function (a) {
    a.addEventListener('click', function () { close(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(field) {
    if (field.dataset.bubbleInit) return;
    field.dataset.bubbleInit = '1';
    var streams = [12, 28, 46, 64, 82];
    var frag = document.createDocumentFragment();
    streams.forEach(function (sx) {
      sx = sx + (Math.random() - 0.5) * 4;
      for (var i = 0; i < 16; i++) {
        var size = 1.5 + Math.random() * 2.5;
        var b = document.createElement('span');
        b.className = 'bubble';
        b.style.width = size + 'px';
        b.style.height = size + 'px';
        b.style.left = (sx + (Math.random() - 0.5) * 1.4) + '%';
        b.style.animationDelay = (Math.random() * 9) + 's';
        b.style.animationDuration = (8 + Math.random() * 5) + 's';
        b.style.setProperty('--drift', ((Math.random() - 0.5) * 14) + 'px');
        frag.appendChild(b);
      }
    });
    for (var k = 0; k < 40; k++) {
      var sz = 1 + Math.random() * 1.2;
      var dust = document.createElement('span');
      dust.className = 'bubble';
      dust.style.width = sz + 'px';
      dust.style.height = sz + 'px';
      dust.style.left = (Math.random() * 100) + '%';
      dust.style.animationDelay = (Math.random() * 12) + 's';
      dust.style.animationDuration = (10 + Math.random() * 6) + 's';
      dust.style.setProperty('--drift', ((Math.random() - 0.5) * 18) + 'px');
      frag.appendChild(dust);
    }
    field.appendChild(frag);
  }
  function boot() {
    document.querySelectorAll('[data-bubble-field]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function initStepper(root) {
    var input = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-decrement]');
    var plus  = root.querySelector('[data-qty-increment]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Currency-agnostic price formatter. Reads shop.money_format from the
  // [data-atb-total] data attribute so the same code works for GBP / USD /
  // EUR / any market the merchant configures.
  function formatMoney(pennies, format) {
    var pounds = pennies / 100;
    var withDecimals = pounds.toFixed(2);
    var trimmed = withDecimals.endsWith('.00') ? withDecimals.slice(0, -3) : withDecimals;
    var noDecimals = Math.round(pounds).toString();
    return (format || '£{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, trimmed)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, trimmed)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  function initVariantPicker() {
    var options = document.querySelectorAll('[data-variant-option]');
    if (options.length === 0) return;

    var initial = null;
    options.forEach(function (o) {
      var r = o.querySelector('input[type="radio"]');
      if (r && r.checked) initial = o;
    });
    if (!initial) initial = options[0];
    initial.setAttribute('data-selected', 'true');

    function selectOption(opt) {
      var radio = opt.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      options.forEach(function (o) {
        var on = (o === opt);
        if (on) o.setAttribute('data-selected', 'true'); else o.removeAttribute('data-selected');
        o.style.background  = on ? 'var(--chorus-black)' : 'transparent';
        o.style.color       = on ? 'var(--chorus-chalk)' : 'var(--chorus-black)';
        o.style.borderColor = on ? 'var(--chorus-black)' : 'var(--hairline-strong)';
      });
      var priceStr = opt.getAttribute('data-variant-price') || '';
      var desc = opt.getAttribute('data-variant-descriptor') || '';
      document.querySelectorAll('[data-active-price]').forEach(function (el) { el.textContent = priceStr; });
      document.querySelectorAll('[data-active-descriptor]').forEach(function (el) { el.textContent = desc; });
      // Swap hero image when the variant has its own featured_image set.
      var imgUrl = opt.getAttribute('data-variant-image-url');
      if (imgUrl) {
        var heroImg = document.querySelector('.product-hero-img');
        if (heroImg) {
          heroImg.removeAttribute('srcset');
          heroImg.src = imgUrl;
        }
      }
      updateAtbTotal();
    }

    function updateAtbTotal() {
      var selected = document.querySelector('[data-variant-option][data-selected="true"]') || options[0];
      if (!selected) return;
      var pennies = parseInt(selected.getAttribute('data-variant-price-pennies'), 10) || 0;
      var qtyEl = document.querySelector('[data-qty-input]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      var atb = document.querySelector('[data-atb-total]');
      if (atb) atb.textContent = formatMoney(pennies * qty, atb.getAttribute('data-currency-format'));
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () { selectOption(opt); });
    });
    var qtyEl = document.querySelector('[data-qty-input]');
    if (qtyEl) {
      qtyEl.addEventListener('input', updateAtbTotal);
      qtyEl.addEventListener('change', updateAtbTotal);
    }
    updateAtbTotal();
  }

  function boot() {
    document.querySelectorAll('[data-qty-stepper]').forEach(initStepper);
    initVariantPicker();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-modal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var modal = document.querySelector('[data-search-modal]');
  if (!modal) return;
  function open() { modal.style.display = 'flex'; modal.setAttribute('aria-hidden', 'false'); document.body.classList.add('lock-scroll'); }
  function close() { modal.style.display = 'none'; modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('lock-scroll'); }

  // Open via any header search button/link
  document.querySelectorAll('a[href$="/search"], button[aria-label="Search"]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      // Allow direct navigation to /search if user middle-clicks etc.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      open();
    });
  });
  // Backdrop click closes
  modal.addEventListener('click', function (e) {
    if (e.target === modal) close();
  });
  // Close button
  modal.querySelectorAll('[data-search-modal-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  // Esc closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-bag"] && !Shopify.designMode) return;
  try {
    
(function () {
  var atb = document.querySelector('[data-sticky-atb]');
  if (!atb) return;
  function update() {
    var y = window.scrollY;
    var max = document.documentElement.scrollHeight - window.innerHeight - 600;
    if (y > 1400 && y < max) {
      atb.style.bottom = '24px';
    } else {
      atb.style.bottom = '-120px';
    }
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();
})();
